import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { serviceDeliveryAPI } from '../lib/api';
import { useAuthStore } from '../store';
import { Card, CardContent } from './ui/card';
import { Loader2, Calendar as CalendarIcon, Building } from 'lucide-react';
import ClientContentCalendar from './ClientContentCalendar';

export function ContentCalendarPage() {
  const { user } = useAuthStore();
  const isAdmin = ['ceo', 'manager'].includes(user?.role);
  const [clients, setClients] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await serviceDeliveryAPI.getClients();
        const list = Array.isArray(data) ? data : (data?.clients || []);
        const norm = list.map((c) => ({ id: c._id || c.id, name: c.nombre || c.name || 'Sin nombre' }));
        setClients(norm);
        if (norm.length > 0) setSelectedId(norm[0].id);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const selectedClient = clients.find((c) => c.id === selectedId);

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-6" data-testid="content-calendar-page">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Calendario de Contenido</h1>
        <p className="text-muted-foreground text-sm mt-1">
          {isAdmin
            ? 'Elige un cliente y gestiona todo su calendario de contenido.'
            : 'Elige un cliente para ver su calendario. Puedes editar cualquier publicación (estado, guion, copy, material); eliminar solo las tuyas.'}
        </p>
      </div>

      {loading ? (
        <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>
      ) : clients.length === 0 ? (
        <Card>
          <CardContent className="py-16 text-center text-muted-foreground">
            <CalendarIcon className="w-12 h-12 mx-auto mb-3 opacity-40" />
            <p>No hay clientes todavía.</p>
          </CardContent>
        </Card>
      ) : (
        <>
          {/* Selector de cliente (pestañas) */}
          <div className="flex flex-wrap gap-2 border-b pb-3" data-testid="client-tabs">
            {clients.map((c) => (
              <button
                key={c.id}
                onClick={() => setSelectedId(c.id)}
                className={`inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-sm font-medium transition-colors ${
                  selectedId === c.id
                    ? 'bg-primary text-primary-foreground shadow-sm'
                    : 'bg-muted text-muted-foreground hover:bg-muted/70'
                }`}
                data-testid={`client-tab-${c.id}`}
              >
                <Building className="w-3.5 h-3.5" />
                {c.name}
              </button>
            ))}
          </div>

          {/* Calendario del cliente seleccionado — idéntico a la vista CEO */}
          {selectedClient && (
            <ClientContentCalendar
              key={selectedClient.id}
              clientId={selectedClient.id}
              clientName={selectedClient.name}
            />
          )}
        </>
      )}
    </motion.div>
  );
}

export default ContentCalendarPage;
